const pathnames = {
	default: "/",
	forgotPassword: "/forgot-password",
	articles: "/articles",
	clients: "/clients",
	client: "/client/",
	faq: "/faq",
	resources: "/resources",
	article: "/article/",
	career: "/career",
	eBrochure: "/e-brochure",
	enquiry: "/enquiry",
	jobApplication: "/job-application",
	solutions: "/solutions",
	popupAds: "/popup-ads",
	popupAdsDetails: "/popup-ads-details/",
	recipientEmail: "/recipient-email",
	partners: "/partners",
	solutionGroup: "/solution-group",
	solutionCategories: "/solution-categories",
	officeLocation: "/office-location",
	officeLocationInfo: "/office-location-info/",
	articlesCategories: "/articles-categories",
	notFound: "*",
};

export default pathnames;
